import React from 'react';

const Footer = () => {
    return (
        <div className="bg-black">
            <div className="text-white text-center py-8">
                {/* Copyright Section */}
                <div className="mb-4">
                    <p className="text-sm md:text-[16px] font-bold">
                        &copy; {new Date().getFullYear()} MoneyLions. All rights reserved.
                    </p>
                </div>
                
                {/* Address Section */}
                <div>
                    <p className="text-xs md:text-[14px] font-medium">
                        Address: Exchange Tower, 106, TRX Circle, Level 26, 55188 Kuala Lumpur, Federal Territory of Kuala Lumpur, Malaysia
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Footer;
